"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelFilter = void 0;
var tslib_1 = require("tslib");
var Model_1 = require("./Model");
var OrderType_1 = require("./OrderType");
var react3l_decorators_1 = require("react3l-decorators");
var ModelFilter = /** @class */ (function (_super) {
    tslib_1.__extends(ModelFilter, _super);
    function ModelFilter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    tslib_1.__decorate([
        react3l_decorators_1.Field(String),
        tslib_1.__metadata("design:type", String)
    ], ModelFilter.prototype, "orderBy", void 0);
    tslib_1.__decorate([
        react3l_decorators_1.Enum(OrderType_1.OrderType),
        tslib_1.__metadata("design:type", String)
    ], ModelFilter.prototype, "orderType", void 0);
    tslib_1.__decorate([
        react3l_decorators_1.Field(Number),
        tslib_1.__metadata("design:type", Number)
    ], ModelFilter.prototype, "skip", void 0);
    tslib_1.__decorate([
        react3l_decorators_1.Field(Number),
        tslib_1.__metadata("design:type", Number)
    ], ModelFilter.prototype, "take", void 0);
    return ModelFilter;
}(Model_1.Model));
exports.ModelFilter = ModelFilter;
//# sourceMappingURL=ModelFilter.js.map